import {ASC} from "./ArrayUtils";

export function toQueryParams(pageInfo) {
    return "page=" + pageInfo.page +
        "&size=" + pageInfo.pageSize +
        "&sortDirection=" + pageInfo.sortDirection.toUpperCase() +
        "&sortProperty=" + pageInfo.sortProperty;
}

export function getDefaultPageInfo(sortProp) {
    return {pageSize: 50, page: 0, sortDirection: ASC, sortProperty: sortProp};
}

/**
 * returns True wenn die PageInfo gleich ist
 * @param pageInfo1
 * @param pageInfo2
 * @returns {boolean}
 */
export function isPageInfoEqual(pageInfo1, pageInfo2) {
    return !(pageInfo1?.page !== pageInfo2?.page
        || pageInfo1?.pageSize !== pageInfo2?.pageSize
        || pageInfo1?.sortDirection !== pageInfo2?.sortDirection
        || pageInfo1?.sortProperty !== pageInfo2?.sortProperty);
}
